export default __webpack_public_path__ + "static/media/img-0735-latvia-half-face.1455b478.png";